<template>
  <div class="auth-bootstrap">
    <div class="auth-bootstrap-card">
      <h4>Preparing Ops Fleet Session</h4>
      <p>Starting enterprise SSO...</p>
    </div>
  </div>
</template>

<script>
import { clearAuthSession } from '../../../helpers/auth/clearAuthSession'
import { getSafeReturnTo } from '../../../helpers/auth/ssoRedirect'
import { loginWithKeycloak } from '../../../services/keycloak'

export default {
  name: 'SsoEntry',
  async mounted () {
    const returnTo = getSafeReturnTo(this.$route.query.returnTo, '/ops/home')

    clearAuthSession()

    try {
      await loginWithKeycloak(returnTo)
    } catch (e) {
      this.$router.replace({ path: '/auth1', query: { error: 'sso_failed' } })
    }
  }
}
</script>

<style scoped>
.auth-bootstrap {
  align-items: center;
  background: #f6f7fb;
  display: flex;
  justify-content: center;
  min-height: 100vh;
}

.auth-bootstrap-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 16px 48px rgba(15, 23, 42, 0.12);
  padding: 32px;
  text-align: center;
}
</style>
